import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { get } from "lodash";
import copy from "copy-to-clipboard";
import {
  IconButton,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import AddIcon from "@mui/icons-material/Add";
import LinkIcon from "@mui/icons-material/Link";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import { memberProject } from "actions/project/memberProject";
import { viewPermissionsSelector } from "views/ProjectGroupPage/selectors";
import MemberSetting from "views/ProjectPage/Modals/MembersSetting";
import Collapse from "./Collapse";
import {
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";

const Member = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const taskDetails = useSelector(
    (state) => state.taskDetail.detailTask.taskDetails
  );
  const project = useSelector(
    (state) => state.project.detailProject.data.project
  );
  const members = useSelector(
    (state) => state.project.memberProject.data.membersAdded || []
  );
  const viewPermissions = useSelector(viewPermissionsSelector);
  const [isOpenMemberSetting, setIsOpenMemberSetting] = React.useState(null);

  const inviteLink =
    window.location.host + "/projects/task-table/" + taskDetails.project;

  React.useEffect(() => {
    if (project?.id) {
      dispatch(memberProject({ projectId: project?.id }));
    }
  }, [project?.id]);

  const handleClickAddMember = (event) => {
    setIsOpenMemberSetting(event.target);
  };

  const handleCopyText = () => {
    copy(inviteLink);
    SnackbarEmitter(
      SNACKBAR_VARIANT.SUCCESS,
      `${t("IDS_WP_ALREADY_COPY")} link`
    );
  };

  return (
    <Collapse
      classes="listPartTabBody--members"
      label={t("LABEL_CHAT_TASK_THANH_VIEN")}
    >
      <List>
        <ListItem disableGutters>
          <div className="MuiListItem-left">
            <ListItemIcon>
              <SupervisorAccountOutlinedIcon />
            </ListItemIcon>
            <ListItemText
              primary={`${Array.isArray(members) ? members.length : ""} ${t(
                "LABEL_CHAT_TASK_THANH_VIEN"
              )}`}
            />
          </div>
          <IconButton onClick={handleClickAddMember}>
            <AddIcon fontSize="medium" />
          </IconButton>
        </ListItem>
        <ListItem disableGutters>
          <div className="MuiListItem-left">
            <ListItemIcon>
              <LinkIcon />
            </ListItemIcon>
            <div>
              <div className="invite-link">
                {t("LABEL_CHAT_TASK_LINK_THAM_GIA")}
              </div>
              <div className="listPartTabBody--members--invite-link">
                <a
                  href={"/projects/task-table/" + taskDetails.project}
                  target="_blank"
                  rel="noreferrer"
                >
                  {inviteLink}
                </a>
              </div>
            </div>
          </div>
          <IconButton onClick={handleCopyText}>
            <ContentCopyRoundedIcon fontSize="medium" />
          </IconButton>
        </ListItem>
      </List>

      {isOpenMemberSetting && (
        <MemberSetting
          open={isOpenMemberSetting}
          setOpen={setIsOpenMemberSetting}
          canEdit={get(
            viewPermissions.permissions,
            [project.id, "update_project"],
            false
          )}
          project_id={project.id}
          project={project}
        />
      )}
    </Collapse>
  );
};

export default Member;
